import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CustomizeService } from '../../../../Services/Customize_settings/customize.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';
import { NotificationService } from '../../../../Services/notification.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-rough-estimate-customization',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './rough-estimate-customization.component.html',
  styleUrls: ['./rough-estimate-customization.component.css']
})
export class RoughEstimateCustomizationComponent implements OnInit {
  selectedFirmId!: number;
  activeEditor: any = null;
  activeEditorLabel: string = '';
  editorPosition = { top: '0px', left: '0px' };
  
  // Mapped to backend field: rough_estimate_layout_settings
  invoiceSettings: any = this.getDefaultSettings();

  constructor(
    private customizeService: CustomizeService,
    private firmSelectionService: FirmSelectionService,
    private notificationService: NotificationService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.firmSelectionService.selectedFirmName$.subscribe((firm: any) => {
      if (firm?.id) {
        this.selectedFirmId = firm.id;
        this.loadLayoutSettings();
      }
    });
  }

  getDefaultSettings() {
    return {
      colors: {
        themeColor: '#006269',
        outerBorder: '#006269',
        totalRowBg: '#9ae3e6',
        balanceRowBg: '#f3f4f6',
        packagingHeaderBg: '#f3f4f6'
      },
      header: {
        // Added 'color' to all these objects
        mainTitle: { text: 'ROUGH ESTIMATE', visible: true, color: '#006269', fontSize: 24 },
        voucherLabel: { text: 'Vou.No.:', visible: true, color: '#374151' },
        dateLabel: { text: 'Date:', visible: true, color: '#374151' }
      },
      table: {
        headers: [
          { text: 'S no.', visible: true, color: '#ffffff' },
          { text: 'Description', visible: true, color: '#ffffff' },
          { text: 'Net Wt', visible: true, color: '#ffffff' },
          { text: 'Tunch', visible: true, color: '#ffffff' },
          { text: 'Pc', visible: true, color: '#ffffff' },
          { text: 'Mrp', visible: true, color: '#ffffff' },
          { text: 'Mrp%', visible: true, color: '#ffffff' },
          { text: 'Quantity', visible: true, color: '#ffffff' },
          { text: 'Lbr', visible: true, color: '#ffffff' },
          { text: 'Fine', visible: true, color: '#ffffff' },
          { text: 'Amount', visible: true, color: '#ffffff' }
        ]
      },
      packaging: {
        visible: true,
        title: { text: 'Packing Details', visible: true, color: '#1f2937' },
        headers: {
          name: { text: 'Minor / Major Name', visible: true, color: '#374151' },
          qty: { text: 'Quantity', visible: true, color: '#374151' }
        },
        emptyMessage: { text: 'No packaging details available.', visible: true, color: '#9ca3af' }
      },
      summary: {
        totalLabel: { text: 'Total', visible: true, color: '#000000' },
        silverValueLabel: { text: 'Silver Value - ₹', visible: true, color: '#000000' },
        receiptCashLabel: { text: 'Receipt Cash', visible: true, color: '#000000' },
        closingBalanceLabel: { text: 'Closing Balance', visible: true, color: '#dc2626' }
      },
      footer: {
        termsTitle: { text: 'Terms & Conditions:', visible: true, color: '#000000' },
        termsText: { text: 'NO RETURN NO EXCHANGE', visible: true, color: '#374151' }
      }
    };
  }

  openEditor(element: any, label: string, event: MouseEvent): void {
    event.stopPropagation();
    this.activeEditor = element;
    this.activeEditorLabel = label;

    const popupWidth = 280;
    const popupHeight = 250;
    let left = event.clientX + 10;
    let top = event.clientY + 10;

    if (left + popupWidth > window.innerWidth) left = event.clientX - popupWidth - 10;
    if (top + popupHeight > window.innerHeight) top = event.clientY - popupHeight - 10;

    this.editorPosition = { top: `${top}px`, left: `${left}px` };
  }

  loadLayoutSettings(): void {
    this.customizeService.getUserSettings(this.selectedFirmId).subscribe({
      next: (res) => {
        const settings = res.data?.['rough_estimate_layout_settings'];
        if (settings) this.invoiceSettings = settings;
      }
    });
  }

  saveLayoutSettings(): void {
    const payload = { 
      customize_firm_id: this.selectedFirmId, 
      'rough_estimate_layout_settings': this.invoiceSettings 
    };
    this.customizeService.saveUserSettings(payload).subscribe({
      next: () => this.notificationService.showSuccess('Estimate Layout Saved', 'Success'),
      error: () => this.notificationService.showError('Failed to save layout', 'Error')
    });
  }

  resetLayoutSettings() {
    if(confirm('Reset all Rough Estimate settings?')) {
      this.invoiceSettings = this.getDefaultSettings();
    }
  }

  goBack(){
    this.router.navigate(['/gst-settings']);
  }
}